import Flickity from 'flickity';

import 'flickity-fade';
import 'flickity-imagesloaded';
import 'flickity/dist/flickity.css';

(() => {
    const reviewsCarouselContainer = document.querySelector(
        '[data-reviews-carousel]',
    );

    if (reviewsCarouselContainer) {
        const reviewsCarousel = new Flickity(reviewsCarouselContainer, {
            // eslint-disable-line no-new
            cellSelector: '[data-reviews-carousel-item]',
            imagesLoaded: true,
            pageDots: false,
            prevNextButtons: true,
            wrapAround: false,
            fade: true,
            contain: false,
            adaptiveHeight: true
        });
    }
})();
